<app-permit-common-details [permit]="permit"></app-permit-common-details>

@if (permit.host) {
    <h3 class="h6 mt-3">Host</h3>
    <dl class="row mb-0">
        <dt class="col-sm-4">Name</dt>
        <dd class="col-sm-8">{{ permit.host.name || '-' }}</dd>

        <dt class="col-sm-4">Phone</dt>
        <dd class="col-sm-8">{{ permit.host.phone || '-' }}</dd>

        @if (permit.host.contact) {
            <dt class="col-sm-4">Email</dt>
            <dd class="col-sm-8">{{ permit.host.contact }}</dd>
        }

        @if (permit.host.permitNumber) {
            <dt class="col-sm-4">Host's permit #</dt>
            <dd class="col-sm-8">{{ permit.host.permitNumber }}</dd>
        }

        <dt class="col-sm-4">Confirmation</dt>
        <dd class="col-sm-8">
            @if (permit.host.confirmed) {
                <span class="badge bg-success">Confirmed</span>
                @if (permit.host.confirmedAt) {
                    <span class="text-muted small ms-1">{{ permit.host.confirmedAt }}</span>
                }
            } @else {
                <span class="badge bg-warning text-dark">Awaiting host</span>
            }
        </dd>
    </dl>
}
